/**
 * 로그인/재로그인 후 돌아갈 경로(`?redirect=`)를 검증한다.
 * - 앱 내부 경로(`/` 로 시작, `//` 로 시작하지 않음)만 허용 (외부 URL 로의 오픈 리다이렉트 방지)
 * - 그 외(`true` 같은 플래그 값, 빈 값, 외부 URL)는 null
 */
export function getSafeRedirectPath(rawRedirect: string | null | undefined): string | null {
  if (!rawRedirect) return null;
  if (!rawRedirect.startsWith('/') || rawRedirect.startsWith('//') || rawRedirect.startsWith('/\\')) return null;
  return rawRedirect;
}
